import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fontsource/archivo/800.css";
import "@/index.css";
import App from "@/App";
import { applyGlass } from "@/lib/glass";

// Překladač prohlížeče přepisuje textové uzly za zády Reactu — removeChild
// pak padá na uzlech s vyměněným rodičem (React issue #11538). Fallback
// nasazujeme JEN když stránka opravdu běží v přeloženém režimu, jinak by
// rozbil komponenty, které DOM přesouvají záměrně (Radix Select/Popover).
if (typeof Node === "function" && Node.prototype) {
  const isTranslated = () =>
    document.documentElement.classList.contains("translated-ltr") ||
    document.documentElement.classList.contains("translated-rtl") ||
    !!document.querySelector("font[_msttexthash], font[class*='notranslate']");

  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this && isTranslated()) return child;
    return origRemoveChild.apply(this, arguments);
  };
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this && isTranslated()) {
      return this.appendChild(newNode);
    }
    return origInsertBefore.apply(this, arguments);
  };
}

// 382: sklo zapnout / vypnout dřív, než se aplikace vykreslí (bez probliknutí)
applyGlass();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register service worker for app-shell caching + offline fallback.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
